(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-gallery"] && !Shopify.designMode) return;
  try {
    /**
   * Video autoplay on hover for product cards (desktop only).
   * Uses event delegation — one listener handles all cards.
   * Videos are lazy-loaded on first hover (preload="none" + data-src on sources).
   */
  (function () {
    // Skip entirely on touch-only devices
    if (window.matchMedia('(hover: none)').matches) return;

    document.addEventListener('mouseover', function (e) {
      var gallery = e.target.closest('[data-hover-video-autoplay]');
      if (!gallery || gallery._hoverVideoActive) return;
      gallery._hoverVideoActive = true;

      var video = gallery.querySelector('.card-gallery__hover-video');
      if (!video) return;

      // Lazy-load video sources on first hover
      if (!video._loaded) {
        var sources = video.querySelectorAll('source[data-src]');
        for (var i = 0; i < sources.length; i++) {
          sources[i].src = sources[i].getAttribute('data-src');
          sources[i].removeAttribute('data-src');
        }
        video.load();
        video._loaded = true;
      }

      video.classList.add('is-playing');
      video.play().catch(function () {});
    });

    document.addEventListener('mouseout', function (e) {
      var gallery = e.target.closest('[data-hover-video-autoplay]');
      if (!gallery) return;
      // Ignore mouseout if we're still inside the gallery
      if (gallery.contains(e.relatedTarget)) return;
      gallery._hoverVideoActive = false;

      var video = gallery.querySelector('.card-gallery__hover-video');
      if (!video) return;

      video.pause();
      video.classList.remove('is-playing');
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
